import { useNavigate } from '@frontend/weave-router';
import type { TaskAction, TaskActionArgs } from '../types';

export function useExploreCallHistoryAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();

  return {
    isEnabled: true,
    onSelect: () => {
      navigate({ to: '/calls/call-history' });
      onClose();
    },
  };
}
